import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, Download, FileDown } from "lucide-react";
import api from "@/lib/api";

const download = async (url, filename) => {
  const { data } = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(data);
  Object.assign(document.createElement("a"), { href, download: filename }).click();
  URL.revokeObjectURL(href);
};

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("es-ES") : "—");

export function DeletionLogSection() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/deletion-certificates").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);

  const exportCsv = () => download("/admin/deletion-certificates.csv", `registro-borrados-${new Date().toISOString().slice(0, 10)}.csv`)
    .then(() => toast.success("Registro exportado")).catch(() => toast.error("No se pudo exportar"));
  const pdf = (id) => download(`/admin/deletion-certificates/${id}/pdf`, `${id}-archivo.pdf`)
    .catch(() => toast.error("No se pudo generar el PDF"));

  return (
    <div className="mt-4 border border-slate-200 bg-white" data-testid="admin-deletion-log">
      <div className="p-6 flex items-start justify-between gap-4 flex-wrap border-b border-slate-200">
        <div className="flex items-start gap-3">
          <ShieldCheck className="w-5 h-5 text-slate-400 mt-1" />
          <div>
            <h3 className="font-display font-bold text-xl">Registro de borrados (art. 17 RGPD)</h3>
            <p className="text-sm text-slate-500 mt-1">Constancia de cada cuenta eliminada, sin datos personales. Úsalo ante una inspección de la AEPD.</p>
          </div>
        </div>
        <button onClick={exportCsv} disabled={!rows?.length} data-testid="deletion-log-csv"
          className="h-10 px-4 border border-slate-200 hover:border-slate-900 text-sm font-bold inline-flex items-center gap-2 disabled:opacity-40 transition-colors">
          <Download className="w-4 h-4" /> Exportar CSV
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>{["Certificado", "Fecha", "Facturas conservadas", "Bloqueo hasta", "Huella SHA-256", ""].map((h) => <th key={h} className="text-left px-4 py-3 kbar">{h}</th>)}</tr>
          </thead>
          <tbody>
            {rows === null && <tr><td colSpan={6} className="p-8 text-center text-slate-400">Cargando…</td></tr>}
            {rows?.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-slate-400" data-testid="deletion-log-empty">Aún no se ha eliminado ninguna cuenta.</td></tr>}
            {rows?.map((r) => (
              <tr key={r.id} className="border-b border-slate-100 hover:bg-slate-50 transition-colors" data-testid={`deletion-row-${r.id}`}>
                <td className="px-4 py-3 font-mono text-xs font-bold">{r.id}</td>
                <td className="px-4 py-3">{new Date(r.created_at).toLocaleString("es-ES")}</td>
                <td className="px-4 py-3">
                  <span className="font-bold">{r.retained_invoices?.length || 0}</span>
                  {r.retained_invoices?.length > 0 && <span className="text-xs text-slate-500 ml-2">{r.retained_invoices.slice(0, 3).join(", ")}{r.retained_invoices.length > 3 ? "…" : ""}</span>}
                </td>
                <td className="px-4 py-3">{fmt(r.retention_until)}</td>
                <td className="px-4 py-3 font-mono text-[10px] text-slate-500" title={r.pdf_sha256}>{r.pdf_sha256?.slice(0, 16)}…</td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => pdf(r.id)} data-testid={`deletion-pdf-${r.id}`}
                    className="h-8 px-3 text-xs font-bold bg-slate-900 text-white hover:bg-slate-800 inline-flex items-center gap-1 transition-colors">
                    <FileDown className="w-3.5 h-3.5" /> PDF
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
